import constants from '../shared/constants';
import { initializeTurnstile } from '../shared/functions';

document.addEventListener('DOMContentLoaded', (): void => {
    const forms = document.querySelectorAll<HTMLFormElement>(constants.targets.contactForm.form);

    forms.forEach((form) => {
        const turnstileContainer = form.querySelector<HTMLElement>(constants.targets.contactForm.turnstile);
        const submitButton = form.querySelector<HTMLButtonElement>(constants.targets.contactForm.submit);

        if (!turnstileContainer || !submitButton) return;

        submitButton.disabled = true;
        submitButton.classList.add(constants.classes.hidden);

        const setSubmitAvailability = (isAvailable: boolean): void => {
            submitButton.disabled = !isAvailable;
            submitButton.classList.toggle(constants.classes.hidden, !isAvailable);
            turnstileContainer.classList.toggle(constants.classes.hidden, isAvailable);
        };

        initializeTurnstile(turnstileContainer, (completed) => {
            setSubmitAvailability(completed);
        });
    });
});
